<!-- <nav class="navbar navbar navbar-expand-md navbar-dark fixed-top"></nav> -->
<!-- <div class="login-niit-logo">
    <img src="assets/logo.svg" alt="NIIT">
</div> -->
<!-- <div class="merry maintenanceMsg {{hide}}" id="merryChristmas" style="width:70%;">
	<img src="https://clockkar.niit.com/Content/image/happyDiwali.jpg" id="merryChristmas-img" alt="" style="width:100%" srcset="">
	<div class="closeMaintenanceMsg" (click)="hidePopup()"><i class="fa fa-close"></i></div>
</div> -->
<!-- Message maintance box -->
<!-- <div class="merry maintenanceMsg {{hide}}" id="merryChristmas" style="width:50%;">
    <img src="./assets/christmas.png" id="merryChristmas-img" alt="" style="width:100%" srcset="">
    <div class="closeMaintenanceMsg" (click)="hidePopup()"><i class="fas fa-times"></i></div>
</div> -->
<div class="loginContainer customizeRtsScrollBar">
  <!-- Using for Christmas/New Year Popup  -->
  <!-- <div class="merry maintenanceMsg" id="merryChristmas" style="display: block">
    <img
      src="https://vsource.niit.com/Content/images/christmas.jpg"
      id="merryChristmas-img"
      alt=""
      style="width: 100%"
    />
    <div class="closeMaintenanceMsg"><i class="fa fa-close"></i></div>
  </div> -->
  <div class="contentHolder">
    <form class="row" [formGroup]="loginForm" (ngSubmit)="authenticatUser()">
      <div class="col-md-12">
        <div class="row logoContainer">
          <div class="col-md-4">
            <img src="assets/logo.svg" class="niit-logo" alt="NIIT" />
          </div>
          <div class="col-md-8">
            <span class="logoTR">
              Talent <br />
              Readiness
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label class="labelName">Login as</label>
          </div>
          <div class="col-md-8 inputDivContainer">
            <select
              formControlName="loginas"
              required="true"
              class="input-container"
            >
              <option value="superadmin">Super Admin</option>
              <option value="tower_head">Tower Head</option>
              <option value="manager">Supervisor</option>
              <option value="hr">HR</option>
              <option value="self">Self</option>
              <option value="view">Training Manager</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label class="labelName">Username</label>
          </div>
          <div class="col-md-8 inputDivContainer">
            <input
              type="text"
              formControlName="username"
              placeholder=""
              class="input-container"
              required="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label class="labelName">Password</label>
          </div>
          <div class="col-md-8 inputDivContainer">
            <input
              type="{{ inputType }}"
              formControlName="password"
              placeholder=""
              class="input-container"
              required="true"
            />
            <span
              toggle="#password-field"
              class="fa fa-eye eye-icon toggle-password"
              (click)="toggle()"
            ></span>
          </div>
        </div>
        <div class="row" *ngIf="isCaptcha">
          <div class="col-md-4">
            <label class="labelName">Captcha</label>
          </div>
          <div class="col-md-7">
            <input
              type="text"
              id="mainCaptcha"
              readonly="readonly"
              class="input-container captchaBg"
            />
          </div>
          <div class="col-md-1">
            <span
              id="refresh"
              class="fa fa-refresh refresh-icon"
              (click)="generateCaptcha()"
            ></span>
          </div>
        </div>
        <div class="row" *ngIf="isCaptcha">
          <div class="col-md-4">
            <label class="labelName">Enter Captcha</label>
          </div>
          <div class="col-md-8">
            <input type="text" id="txtInput" class="input-container" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 loginButton">
            <button class="btn hvr-bounce-to-top">Login</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="loader" *ngIf="loading">
    <div class="lds-roller">
      <!-- <img src="assets/preloader.gif" />
            <span>Wait...</span> -->
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
<div class="footer">
  <p>&copy; 2021 NIIT Talent Readiness. All rights reserved. Powered by NEC.</p>
</div>
